import styled from '@emotion/styled';
import classnames from 'classnames';
import React from 'react';

import colors from 'config/theme/colors';

export const Counter = styled.span`
  font-size: 12px !important;
  color: ${colors['@success-color']};

  transition: 1s all;

  &.over {
    color: ${colors['@error-color-dark']};
  }

  &.equals {
    color: ${colors['@warning-color-light']};
  }
`;

type CharCounterProps = {
  max?: number;
  value?: number;
  className?: string;
  separator?: string;
  tagName?: React.ElementType;
};

const CharCounter: React.FC<CharCounterProps> = ({
  max = 0,
  value = 0,
  className,
  separator = '/',
  tagName: TagName = Counter,
}) => (
  <TagName
    max={max}
    value={value}
    className={classnames(className, {
      over: value > max,
      equals: value === max,
      under: value < max
    })}
  >
    {value}
    {separator}
    {max}
  </TagName>
);

export default CharCounter;
